import { QueryClient } from "@tanstack/react-query";
import React, { createContext, FC, PropsWithChildren, useEffect } from "react";

const queryClientContext = createContext<QueryClient | undefined>(undefined);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

const QueryClientProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  // No TanStack <QueryClientProvider> on purpose: v5 dropped the `context` option, and
  // publishing this client on TanStack's default context would hijack the queries of the
  // host app and of the libraries rendered below (payments-front, promocodes-front...).
  // Keeping the client on our own context preserves the isolation `context` used to give;
  // the hooks receive it as their second argument. Manual mount()/unmount() is what keeps
  // the focus/online managers wired without TanStack's provider.
  useEffect(() => {
    queryClient.mount();

    return () => {
      queryClient.unmount();
    };
  }, []);

  return <queryClientContext.Provider value={queryClient}>{children}</queryClientContext.Provider>;
};

export { QueryClientProvider, queryClientContext };
